import React, { useRef, useEffect, Fragment, useContext } from 'react';
import { gsap } from 'gsap';
import './Statistics.scss';
import { WidthContext } from '../../WidthContext';

function Statistics1() {
  const width = useContext(WidthContext);
  const container = useRef();
  const barRef0 = useRef();
  const barRef1 = useRef();
  const barRef2 = useRef();
  const barRef3 = useRef();
  const barRef4 = useRef();
  const barRef5 = useRef();
  const barRef6 = useRef();
  const barRef7 = useRef();
  const barRef8 = useRef();
  const barRef9 = useRef();
  const barRef10 = useRef();
  const barRef11 = useRef();

  const barRefs = useRef();
  const dataRefs = useRef();

  barRefs.current = [
    barRef0,
    barRef1,
    barRef2,
    barRef3,
    barRef4,
    barRef5,
    barRef6,
    barRef7,
    barRef8,
    barRef9,
    barRef10,
    barRef11
  ];

  dataRefs.current = [42, 40, 40, 36, 41, 50, 39, 33, 35, 33, 31, 26];
  useEffect(() => {
    barRefs.current.forEach((ref, i) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: 'top 75%',
          end: 'top 75%',
          once: true
        }
      });

      tl.to(ref.current, {
        height: width > 767 ? `${dataRefs.current[i]}%` : null,
        width: width < 768 ? `${dataRefs.current[i]}%` : null,
        duration: 1.2
      }).to('.bar-number-1', { opacity: 1, duration: 0.7, ease: 'ease-in' }, '-=0.5');
    });
  }, [width]);

  return (
    <figure className="statistics">
      <div className="statistics__graphic" ref={container}>
        <h3 className="statistics__graphic__title statistics__graphic__title-1">
          Percentage of first-time home buyers hits all-time low in 2022
        </h3>

        <div className="statistics__graphic-container">
          <div className="statistics__graphic__graph statistics__graphic__graph-1">
            <div className="statistics__graphic__graph__range">
              <span>100%</span>
              <span>0%</span>
            </div>
            {dataRefs.current.map((el, i) => {
              return (
                <Fragment key={`${el}-${i}`}>
                  <div className="bar bar-1">
                    <div className="bar-container bar-container-1">
                      <span
                        className={
                          !dataRefs.current[i + 1]
                            ? 'bar-number bar-number-1  bar-number-1--last'
                            : 'bar-number bar-number-1'
                        }
                      >
                        {el}%
                      </span>
                      <div
                        className={
                          !dataRefs.current[i + 1]
                            ? 'bar-left bar-left-1 bar-left-1--last'
                            : 'bar-left bar-left-1'
                        }
                        ref={barRefs.current[i]}
                      />
                    </div>
                  </div>
                </Fragment>
              );
            })}
          </div>
          <div className="statistics__graphic__range__label statistics__graphic__range__label-1">
            {[...Array(12)].map((_, i) => (
              <span className="statistics__graphic__range__label-1__text">{2000 + i * 2}</span>
            ))}
          </div>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics1;
